import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    failureCourseResources,
    successCourseResources,
} from "./CourseResourcesSlice";

const CourseResourcesApi = (action: PayloadAction<{ subject_id: string | number; resource_type: string }>) => {
    const { subject_id, resource_type } = action.payload;
    return api.get(`/api/course/resources/${subject_id}/${resource_type}`);
};

export function* CourseResourcesCall(action: PayloadAction<any>) {
    try {
        const response: AxiosResponse = yield call(CourseResourcesApi, action);
        // Sometimes APIs wrap data in a 'data' field
        const result = response.data?.data || response.data;
        yield put(successCourseResources(result));
    } catch (error) {
        yield put(failureCourseResources(error));
    }
}
